import React, { useState } from 'react'
import { CiGrid41 } from 'react-icons/ci'
import { FiBookOpen } from 'react-icons/fi'
import { AiOutlineSend, AiOutlineFolderAdd } from 'react-icons/ai'
import { MdOutlineSettings, MdOutlineCreate } from 'react-icons/md'
import { BsArrowLeft } from 'react-icons/bs'

let tabs = [
  { link: '#', Icon: CiGrid41 },
  { link: '#', Icon: FiBookOpen },
  { link: '#', Icon: AiOutlineSend },
  { link: '/create', Icon: MdOutlineCreate },
  { link: '#', Icon: MdOutlineSettings },
  { link: '#', Icon: AiOutlineFolderAdd },
]

const Sidebar = ({ open, setOpen }) => {
  let [selectedTabIndex, setSelectedTabIndex] = useState(0)
  return (
    <div
      className={`flex fixed md:static inset-0 md:w-fit w-full ${
        open ? 'z-50' : '-z-50'
      } md:z-50`}
    >
      <div
        className={`"w-[110px] px-4 h-screen md:sticky fixed top-0 md:left-0 z-50  bg-[#16161b] ${
          open ? 'left-0' : 'left-[-94px]'
        } flex flex-col  items-center py-5 px-4 transition-all duration-200"`}
      >
        <a href={'/'} className="hidden md:flex flex-col items-center">
          <img src="/images/logo.svg" className="h-12 w-auto" />
          <h3 className="text-white text-base font-bold mt-1.5">Taskie</h3>
        </a>
        <div className="flex md:hidden bg-[#0e0e0e] py-2 px-2 rounded-md">
          <BsArrowLeft
            className="text-white h-6 w-auto"
            onClick={() => setOpen(false)}
          />
        </div>
        <div className="flex-grow flex flex-col justify-center items-center gap-y-4">
          {tabs.map((Tab, i) => (
            <a
              key={i}
              href={Tab.link}
              onClick={() => {
                setSelectedTabIndex(i)
              }}
              className={`group rounded-[14px] ${
                i == selectedTabIndex ? 'bg-[#5051F9]' : 'bg-transparent'
              }  hover:bg-[#5051F9] py-3 px-3 cursor-pointer transition-all duration-200`}
            >
              <Tab.Icon
                className={` font-bold group-hover:text-white h-6 w-auto ${
                  i == selectedTabIndex ? 'text-white' : 'text-[#5F6388]'
                }`}
              />
            </a>
          ))}
        </div>
      </div>
      <button
        onClick={() => setOpen(false)}
        className={`w-[calc(100vw - 110px)] md:hidden  h-screen fixed right-0 top-0 bottom-0 left-0 bg-gray-500 bg-opacity-10 ${
          open ? 'block' : 'hidden'
        }`}
      ></button>
    </div>
  )
}

export default Sidebar
